export enum BaseRoutesEnum {
    // sessions
    sessions = '/sessions',
    // intentions
    intentionsImport = '/mes-intentions/intentions-import',
    myIntentions = '/mes-intentions',
    allIntentions = '/toutes-les-intentions',
    myArchivedIntentions = '/mes-intentions-archivees',
    allArchivedIntentions = '/toutes-les-intentions-archivees',

    // opportunities
    myOpportunities = '/mes-opportunites',
    allOpportunities = '/toutes-les-opportunites',

}
